"use client";

import { useMemo, useState } from "react";
import type { CaseStudy, CaseStudyService } from "@/data/caseStudies";
import CaseStudyCard from "./CaseStudyCard";

type Filter = "All" | CaseStudyService;

export default function CaseStudyGrid({ stories }: { stories: CaseStudy[] }) {
  const services = useMemo(() => {
    const seen: CaseStudyService[] = [];
    stories.forEach((story) => {
      if (story.service && !seen.includes(story.service)) seen.push(story.service);
    });
    return seen;
  }, [stories]);

  const [active, setActive] = useState<Filter>("All");
  const visible = active === "All" ? stories : stories.filter((story) => story.service === active);
  const filters: Filter[] = ["All", ...services];

  return (
    <div>
      {services.length > 0 ? (
      <div className="mb-8 flex flex-wrap gap-2" role="group" aria-label="Filter stories by service">
        {filters.map((service) => {
          const selected = active === service;
          return (
            <button
              key={service}
              type="button"
              aria-pressed={selected}
              onClick={() => setActive(service)}
              className={`rounded-full px-4 py-2 text-sm transition focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#54169C] ${
                selected
                  ? "bg-gradient-to-r from-[#DA159B] to-[#54169C] text-white shadow-sm"
                  : "bg-white text-gray-700 ring-1 ring-[#54169C]/15 hover:ring-[#DA159B]"
              }`}
            >
              {service}
            </button>
          );
        })}
      </div>
      ) : null}

      {visible.length === 0 ? (
        <p className="text-gray-600">No stories in this service yet.</p>
      ) : (
        <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {visible.map((story) => (
            <li key={story.slug} className="min-w-0">
              <CaseStudyCard story={story} />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
